import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

interface TabProps {
  name: string;
  children: React.ReactNode;
}

const TabContent: React.FC<TabProps> = (props) => {
  const { name, children } = props;

  return <div className="w-full h-full">{children}</div>;
};

interface TabsProps {
  tab1: TabProps;
  tab2: TabProps;
  tabGroupTitle?: string;
  activeTab?: string;
  isDonutTabHidden?:boolean;
  titleClassName?: string;
}

const DashboardTabs: React.FC<TabsProps> = (props) => {
  const { tab1, tab2, tabGroupTitle } = props;
  const [activeTab, setActiveTab] = useState(props.activeTab ?? tab1.name);
  const [screenWidth, setScreenWidth] = React.useState<number>(
    document.documentElement.clientWidth
  );

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const resizeCallback = () => {
      setScreenWidth(document.documentElement.clientWidth);
    };
    window.addEventListener('resize', resizeCallback);

    return () => {
      window.removeEventListener('resize', resizeCallback);
    };
  }, []);

  const activeButtonClassNames = ` text-black bg-[#FBC02D] shadow px-3 py-1 text-sm font-medium rounded-full w-full whitespace-nowrap`;
  const inActiveButtonClassNames = 'text-[#5B5B5B] px-3 py-1 text-sm font-medium rounded-full w-full whitespace-nowrap';

  return (
    <>
      <div
        className={clsx(
          'flex items-center',
          { ['flex flex-row justify-between w-full mb-5']: screenWidth > 1213 },
          { ['flex-row space-x-2']: screenWidth <= 1213 }
        )}>
        {tabGroupTitle && (
          <div className={` ${props.titleClassName} md:w-full pb-4 md:pb-2 text-md sm:text-md md:text-xl font-bold dark:text-darkBg-mainText `}>
            {tabGroupTitle}
          </div>
        )}
        <div className={` ${props.isDonutTabHidden ? 'hidden' : '' } flex items-center space-x-2 bg-gray-100 p-1 rounded-full`}>
          <button
            className={` ${
              activeTab === tab1.name ? activeButtonClassNames : inActiveButtonClassNames
            }`}
            onClick={() => handleTabChange(tab1.name)}>
            {tab1.name}
          </button>
          <button
            className={`rounded-full ${
              activeTab === tab2.name ? activeButtonClassNames : inActiveButtonClassNames
            }`}
            onClick={() => handleTabChange(tab2.name)}>
            {tab2.name}
          </button>
        </div>
      </div>
      <div className="flex justify-center h-full">
        {activeTab === tab1.name && <TabContent name={tab1.name}>{tab1.children}</TabContent>}
        {activeTab === tab2.name && <TabContent name={tab2.name}>{tab2.children}</TabContent>}
      </div>
    </>
  );
};

export default DashboardTabs;
